import {
  IProductSelectorTemplate,
  PagedRequest,
  PagedResponse,
} from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';

const productSelectorsApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getSelectorTemplates: build.query<
      PagedResponse<IProductSelectorTemplate[]>,
      PagedRequest & {
        search?: string;
        includeArchived?: boolean;
      }
    >({
      query: (request) => ({
        url: 'product-selector-templates',
        method: 'GET',
        params: request,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({
                type: 'ProductSelectorTemplates' as const,
                id: _id.toString(),
              })),
              {
                type: 'ProductSelectorTemplates',
                id: 'PARTIAL-LIST',
              },
            ]
          : [
              {
                type: 'ProductSelectorTemplates',
                id: 'PARTIAL-LIST',
              },
            ],
    }),
    getSelectorTemplate: build.query<IProductSelectorTemplate, string>({
      query: (id) => ({
        url: `product-selector-templates/${id}`,
        method: 'GET',
      }),
      providesTags: (result) => [
        {
          type: 'ProductSelectorTemplates' as const,
          id: result?._id.toString(),
        },
      ],
    }),
    createSelectorTemplate: build.mutation<
      IProductSelectorTemplate,
      Partial<IProductSelectorTemplate>
    >({
      query: (request) => ({
        url: 'product-selector-templates',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: (result) => [
        { type: 'ProductSelectorTemplates', id: 'PARTIAL-LIST' },
        { type: 'ProductSelectorTemplates', id: result?._id.toString() },
      ],
    }),
    updateSelectorTemplate: build.mutation<
      IProductSelectorTemplate,
      { id: string; data: Partial<IProductSelectorTemplate> }
    >({
      query: (request) => ({
        url: `product-selector-templates/${request.id}`,
        method: 'PUT',
        body: request.data,
      }),
      invalidatesTags: (result, error, request) => [
        { type: 'ProductSelectorTemplates', id: 'PARTIAL-LIST' },
        { type: 'ProductSelectorTemplates', id: request.id },
      ],
    }),
    deleteSelectorTemplate: build.mutation<string, string>({
      query: (id) => ({
        url: `product-selector-templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'ProductSelectorTemplates', id: 'PARTIAL-LIST' },
        { type: 'ProductSelectorTemplates', id },
      ],
    }),
  }),
});

export const {
  useGetSelectorTemplatesQuery,
  useGetSelectorTemplateQuery,
  useCreateSelectorTemplateMutation,
  useUpdateSelectorTemplateMutation,
  useDeleteSelectorTemplateMutation,
} = productSelectorsApi;
